import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, map, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserLogin } from '../models/user.login';
import { UserCategory } from '../models/user.category';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private httpClient: HttpClient
  ) { }

  validateUserWithPassword(email: string,password: string): Observable<UserLogin> {
    const url = `${environment.gateway_url}/user/${email}/${password}`
    return this.httpClient.get<UserLogin>(url).pipe(
      map(item => {
        return item;
      })
    );
  }
  getAllCategories(): Observable<UserCategory[]>{
    const url = `${environment.gateway_url}/getallcategorys`
    return this.httpClient.get<any[]>(url).pipe(
      map(item => {
        return item;
      })
    );
  }
  //Azure auth
  getCurrentUser(): Observable<any> {
  return this.httpClient.get<any>(
    `${environment.gateway_url}/user/me`
  );
}
}
